import { Link } from 'react-router-dom';

const footerColors = {
  bg: '#1C2033',
  text: '#6B6F85',
};

export function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.footerInner}>
        <Link to="/" style={styles.footerLogoLink}>
          <img src="/img/snagg_assets/snagg_combined_light.svg" alt="snagg" style={styles.footerLogoImg} />
        </Link>
        <div style={styles.footerBottom}>
          <div style={styles.footerLinks}>
            <span style={styles.footerCopy}>&copy;2026 Snagg, LLC.</span>
            <Link to="/about" style={styles.footerLink}>About</Link>
            <Link to="/terms" style={styles.footerLink}>Terms</Link>
            <Link to="/privacy" style={styles.footerLink}>Privacy</Link>
            <Link to="/support" style={styles.footerLink}>Support</Link>
          </div>
          <div style={styles.footerRight}>
            {/* Social icons will go here */}
          </div>
        </div>
      </div>
    </footer>
  );
}

const styles: Record<string, React.CSSProperties> = {
  footer: {
    backgroundColor: footerColors.bg,
    padding: '40px 0 32px',
    marginTop: 'auto',
  },
  footerInner: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  footerLogoLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    textDecoration: 'none',
  },
  footerLogoImg: {
    height: 32,
    width: 'auto',
    display: 'block',
  },
  footerBottom: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  footerLinks: {
    display: 'flex',
    alignItems: 'center',
    gap: 24,
  },
  footerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  footerLink: {
    fontSize: 14,
    color: footerColors.text,
    textDecoration: 'none',
    transition: 'color 0.2s',
    padding: '12px 0',
    minHeight: 44,
    display: 'inline-flex',
    alignItems: 'center',
  },
  footerCopy: {
    fontSize: 13,
    color: footerColors.text,
  },
};
